const createToast = ({ type, message, btnTitle, onClick }) => {
  return {
    id: Math.floor(Math.random() * 1000),
    type,
    message,
    btnTitle,
    onClick,
  };
};
export const createEmailConfirmationToast = (setToastList, message) => {
  setToastList(prevState => [
    ...prevState,
    createToast({
      type: 'emailConfirmation',

      message: message,
    }),
  ]);
};
export const createSuccessToast = (setToastList, message) => {
  setToastList(prevState => [
    ...prevState,
    createToast({
      type: 'success',

      message: message,
    }),
  ]);
};

export const createErrorToast = (setToastList, message) => {
  setToastList(prevState => [
    ...prevState,
    createToast({
      type: 'error',

      message: message,
    }),
  ]);
};

export const createTrashToast = (setToastList, message) => {
  setToastList(prevState => [
    ...prevState,
    createToast({
      type: 'trash',

      message: message,
    }),
  ]);
};
export const createGenericErrorToast = setToastList => {
  setToastList(prevState => [
    ...prevState,
    createToast({
      type: 'error',

      message: 'Ocorreu um erro. Tente novamente.',
    }),
  ]);
};
export const createDarkSuccessToast = (setToastList, message) => {
  setToastList(prevState => [
    ...prevState,
    createToast({
      type: 'darkSuccess',

      message: message,
    }),
  ]);
};
export const removePendingToast = setToastList => {
  setToastList(prev => prev.filter(t => t.id !== 'outbox-pending'));
};
export const createPendingToast = (setToastList, message) => {
  const FIXED_ID = 'outbox-pending';

  setToastList(prevState => {
    const alreadyExists = prevState.find(t => t.id === FIXED_ID);

    if (alreadyExists) return prevState;

    return [
      ...prevState,
      {
        ...createToast({
          type: 'loading',
          message,
        }),
        id: FIXED_ID,
        autoDelete: false,
      },
    ];
  });
};
export const removeErrorToasts = setToastList => {
  setToastList(prev => prev.filter(t => t.type !== 'error'));
};
export { createToast };
